module.exports = __webpack_public_path__ + "static/media/daringfood_expowest_2.668cf4e0.png";